import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getCardEntities } from './EntitiesSelector';

const getCardSearch = state => state.getIn(['cards', 'cardSearch'], Immutable.Map());

export const getCardsForSearch = createSelector(
  [getCardSearch, getCardEntities],
  (cardSearch, cardEntities) => cardSearch.get('results').map(cardId => cardEntities.get(cardId.toString()))
);

export const getCardSearchParameters = createSelector(
  [getCardSearch],
  cardSearch => cardSearch
);

export default {
  getCardsForSearch,
  getCardSearchParameters
};
